// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1nU-_","left":"InfoRow_left__1wCL7"};